import React, { useEffect, useState } from 'react';
import { Table, Dropdown, Menu, Checkbox, Select, Button, Modal, message } from 'antd';
import { ContactsFilled, EllipsisOutlined, UnorderedListOutlined } from '@ant-design/icons';
import TextArea from 'antd/lib/input/TextArea';
import { partnerChangeHistoryData, remarkData } from '../helper/payoutdatasample';
import PartnerChangeHistory from '../PartnerChangeHistory';
import RemarksComponent from '../RemarksComponent';
import { connect } from 'react-redux';
import { getremaphystorydata, getRemarksLanSuccess } from '../../../redux/PayoutLanData/Action';
import { Payout_Service } from '../../../redux/Url';
import { render } from '@testing-library/react';
import useSession from '../../CustomLogout/useSession';
import { Spin } from 'antd';

const { Option } = Select;

const LanlistWithPayoutCPChecker = (props) => {
  const {
    landataSource,
    setLanDatasource,
    makerAction,
    checkerAction,
    setMakerAction,
    setCheckerAction,
    handleRadioChange,
    radiostate,
    setRadioState,
    handleCheckboxChange,
    selectedCheckboxes,
    partnerId,
    ReportId,
    pagination,
    onPageChange,
    downloadAction,
    setDownloadAction,
    recovery,
    setRecovery,
    fileApprovalId,
    setFileApprovalId,
    remap,
    setRemap,
    downloading,
  } = props;

  const handleSessionExpired = useSession();
  const [datasource, setDatasource] = useState([]);
  const [editableRow, setEditableRow] = useState(null);
  const [selectedPartner, setSelectedPartner] = useState('');
  const [pmapremark, setPmapremark] = useState("");
  const [ispmapremarkVisble, setPmapremarkVisble] = useState(false);
  const [isholdPayoutVisble, setIsholdPayoutVisble] = useState(false);
  const [partnerChangeOpen, setPartnerChangeOpen] = useState(false);
  const [partnerChangeData, setPartnerChangeData] = useState(partnerChangeHistoryData);
  const [remarks, setRemarks] = useState(false);
  const [resDataRM, setresDataRm] = useState([]);
  const [isLoading, setIsLoading] = useState(null);




  useEffect(() => {
    setDatasource(landataSource);
  }, [landataSource, radiostate]);

  const handleMenuClick = (record, action) => {
    if (action === 'ExportCSV') {
    } else if (action === 'ExportExcel') {
    } else if (action === 'RemappingHistory') {
      setPartnerChangeOpen(true);
      fechRemapdata(record)
    } else if (action === 'AddRemark') {
      setRemarks(true);
    }
  };

  const handlePartnerChange = (value, record) => {
    setSelectedPartner(value);
    setPmapremarkVisble(true);
  };

  const handleCloseModalpmapremark = () => {
    setPmapremarkVisble(false);
    setPmapremark("");
  }
  const handleCloseModalholdPaout = () => {
    setIsholdPayoutVisble(false);
  }

  const handelsavePremark = () => {
    setPmapremarkVisble(false);
  }


  const fechRemapdata = async (record) => {

    try {
      const resgetReampHdata = props.getremaphystorydata({
        accessToken: props.accessToken,
        lanNo: record.lanNo
      });

      const data = await resgetReampHdata;
      const errorCode = resgetReampHdata?.response?.data?.error?.errorCode || resgetReampHdata?.response?.status;
      if (errorCode && errorCode === "403" && (resgetReampHdata?.response?.data?.error?.errorCode || resgetReampHdata?.response?.status)) {
        handleSessionExpired(); //Logout the user if session expired
        return;
      }
      setPartnerChangeData(data || []);

    } catch (error) {
      console.error("Error fetching remap history data:", error);
      message.error("Failed to fetch remap history data");


    }

  }

  const formatRemarks = (remarks) => {
    const sortdata = remarks.sort((a, b) => {
      const dateA = new Date(a.createDateTime);
      const dateB = new Date(b.createDateTime);

      // For debugging

      return dateA.getTime() - dateB.getTime(); // Newest first
    });

    return remarks
      ?.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))
      .map((remarks) => (
        <div className='containerRemarks' style={{ display: 'block' }} key={remarks.lanRemarkId}>
          <div style={{ display: 'flex' }}>
            <b>{remarks.createdByName}</b>
            <b className='userRole' >({remarks.createdByRole})</b>
          </div>
          <div style={{ display: 'grid' }} className='commentContainer'>
            <span style={{ maxWidth: "200px" }}> {remarks.remarks} </span>
            <small>
              {new Date(remarks.createdDate).toLocaleString()}| Reason:{remarks.lanRemarkType}
            </small>
          </div>
        </div>
      ));
  };

  // var resData = formatRemarks(remarkData)

  const handleSavePartnerChange = (record) => {
    // setSelectedPartner(value);
    const updatedData = datasource.map((item) => {
      if (item.DISB_FILE_NO === record.DISB_FILE_NO) {
        return { ...item, PartnerName: selectedPartner };
      }
      return item;
    });
    setDatasource(updatedData);
    setEditableRow(null);
    setSelectedPartner('');
    setPmapremark("");
  };



  const fatechRemarLanLavel = async (record) => {

    const lanRemarkdata = await props.getLanRemarkData({
      accessToken: props.accessToken,
      payoutId: record.payoutId
    })

    return lanRemarkdata;


  }

  const handleRemarksModal = async (record, key) => {

    setIsLoading(key);

    const resData1 = await fatechRemarLanLavel(record)
    setIsLoading(null);

    const flatArray = Object.values(resData1).flat();

    const resData = formatRemarks(flatArray)

    if (resData.length > 0) {
      setresDataRm(resData);
      setRemarks(true);
    } else {
      message.warning("No remarks found for this record.");
    }
  }

  const downloadReport = async (format) => {
    try {
      const response = await fetch(
        // `http://localhost:8301/partner-payout-service/reports/payout-lan-report-export?lanTab=${radiostate}&reportId=${ReportId}&partnerId=${partnerId}&format=${format}`,
        `${Payout_Service}/reports/payout-lan-report-export?lanTab=${radiostate}&reportId=${ReportId}&partnerId=${partnerId}&format=${format}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + props.accessToken, // Use the access token from props
          },
        }
      );
      if (!response.ok) throw new Error('Network response was not ok');
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = format === 'csv' ? 'report.csv' : 'report.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      message.success('Successfully downloaded the report');
      window.URL.revokeObjectURL(url);
    } catch (error) {
      message.error('Download failed:', error);
    }
  };


  const handleHeaderMenuClick = (key) => {
    switch (key) {
      case 'ExportCSV':
        downloadReport('csv');
        break;
      case 'ExportExcel':
        downloadReport('excel');
        break;
      case 'AddRemark':
        setRemarks(true)
        break;
      default:
        break;
    }
  };

  const headerMenu = (
    <Menu
      onClick={({ key }) => handleHeaderMenuClick(key)}
      items={[
        { label: 'Export to CSV', key: 'ExportCSV' },
        { label: 'Export to Excel', key: 'ExportExcel' },
        // { label: 'Hold Payout(Bulk Action)', key: 'HoldPayoutBulk' },
        // { label: 'Add/ View Remark(Partner)', key: 'AddRemark' },
      ]}
    />
  );

  // const optionOfReasion =[
  //   {
  //     value: 'jack',
  //     label: 'Jack',
  //   },
  //   {
  //     value: 'lucy',
  //     label: 'Lucy',
  //   },
  //   {
  //     value: 'tom',
  //     label: 'Tom',
  //   },
  // ]

  const columns = [
    // ...(makerAction && checkerAction
    //   ? [
    //       {
    //         title: 'Check',
    //         dataIndex: 'Check',
    //         key: 'Check',
    //         fixed: 'left',
    //         width: 60,
    //         render: (_, record) => (
    //           <Checkbox
    //             checked={selectedCheckboxes.Check.includes(record)}
    //             onChange={(e) => handleCheckboxChange(e, 'Check', record)}
    //           />
    //         ),
    //       },
    //     ]
    //   : []),
    {
      title: 'Applicant Name',
      dataIndex: 'applicantName',
      key: 'applicantName',
      align: 'center',
    },
    {
      title: 'DISB_FILE_NO',
      dataIndex: 'lanNo',
      key: 'lanNo',
      align: 'center',
      width: 190,
    },
    {
      title: 'Disbursal Date',
      dataIndex: 'disbDate',
      key: 'disbDate',
      align: 'center',
      width: 190,
    },
    {
      title: 'Partner Name',
      dataIndex: 'partnerName',
      key: 'partnerName',
      align: 'center',
      width: 200,
    },
    {
      title: 'Partner Code',
      dataIndex: 'partnerCode',
      key: 'partnerCode',
      align: 'center',
      width: 190,
    },
    {
      title: '1st Disb Amount',
      dataIndex: 'firstDisbAmount',
      key: 'firstDisbAmount',
      align: 'center',
      width: 190,
      render: (_, record) => (record.disbSeq > 1 ? 0 : record.firstDisbAmount)?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Tranche Disb Amount',
      dataIndex: 'disbAmount',
      key: 'disbAmount',
      align: 'center',
      width: 190,
      render: (_, record) => (record.disbSeq > 1 ? record.disbAmount : 0)?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Disb Cumulative',
      dataIndex: 'cumulativeAmount',
      key: 'cumulativeAmount',
      align: 'center',
      width: 190,
      render: (_, record) => {
        const cumulative = record.cumulativeAmount || 0;
        return cumulative.toLocaleString("en-IN", { style: "currency", currency: "INR" });
      }
    },
    {
      title: 'Payout Status',
      dataIndex: 'transactionStatus',
      key: 'transactionStatus',
      align: 'center',
      width: 190,
    },
    {
      title: 'Credit Amount',
      dataIndex: 'creditAmount',
      key: 'creditAmount',
      align: 'center',
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Debit Amount',
      dataIndex: 'debitAmount',
      key: 'debitAmount',
      align: 'center',
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Percentage Applied',
      dataIndex: 'percentage',
      key: 'percentage',
      align: 'center',
      width: 100,
      render: (value) => value !== undefined && value !== null ? `${value}%` : '-',
    },
    //  {
    //    title: 'Status Amount',
    //    dataIndex: 'regular',
    //    key: 'regular',
    //  },
    {
      title: 'Remark',
      dataIndex: 'Remark',
      key: 'Remark',
      align: 'center',
      render: (_, record, key) => (
        <Button loading={isLoading === key} className='remarkView-btn' style={{ border: "none", color: "#000", fontSize: "14px" }} onClick={() => handleRemarksModal(record, key)} >
          Remark
        </Button>
      )
    },
    ...(recovery
      ? [
        {
          title: 'Recovery Final Amount',
          dataIndex: 'finaRecoveryAmount',
          key: 'finaRecoveryAmount',
          align: 'center',
          width: 170,
          render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
        },
      ]
      : []
    ),
    ...(makerAction || checkerAction || downloadAction || remap
      ? [
        {
          title: (
            downloadAction ? (
              <Dropdown overlay={headerMenu} trigger={['click']}>
                <span style={{ cursor: 'pointer' }}>
                  Action <EllipsisOutlined />
                </span>
              </Dropdown>
            ) : (
              <span style={{ cursor: 'not-allowed', color: '#ccc' }}>
                Action <EllipsisOutlined />
              </span>
            )
          ),
          dataIndex: 'Action',
          key: 'Action',
          fixed: 'right',
          width: 100,
          align: 'center',
          render: (_, record) => {
            const menu = (
              <Menu
                onClick={({ key }) => handleMenuClick(record, key)}
                items={[
                  { label: 'Remapping History', key: 'RemappingHistory' },
                ]}
              />
            );

            return (
              <>
                {remap ? <Dropdown overlay={menu} trigger={['click']}>
                  <UnorderedListOutlined
                    style={{ cursor: 'pointer', fontSize: '18px' }}
                  />
                </Dropdown> : <></>}

              </>
            );
          },
        },
      ]
      : []),
  ];

  return (
    <div style={{ maxWidth: '100%' }}>
      {downloading && (
        <div style={{
          position: 'absolute',
          zIndex: 10,
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(255,255,255,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Spin tip="Loading..." size="large" />
        </div>
      )}
      <Table dataSource={datasource}
        pagination={pagination}
        onChange={(pagination) => {
          // Call the parent's handler if provided
          if (props.onPageChange) {
            props.onPageChange(pagination.current, pagination.pageSize, radiostate);
          }
        }} columns={columns} rowKey={(record, index) => index} scroll={{ x: 'max-content', y: 'calc(100vh - 300px)' }} />
      <Modal
        title="Add Remark"
        visible={ispmapremarkVisble}
        onCancel={handleCloseModalpmapremark}
        footer={null}
      >
        <TextArea
          placeholder="Please add comment to submit"
          onChange={(e) => setPmapremark(e.target.value)}
          autoSize={{ minRows: 2, maxRows: 6 }}
        />
        <Button
          disabled={pmapremark === null}
          type="link"
          onClick={() => handelsavePremark()}
          style={{ background: "#1b8593", marginTop: "0.3rem", color: "#fff" }}
        >
          Submit
        </Button>

      </Modal>

      {/* <Modal
      title="Hold Payout"
      visible={isholdPayoutVisble}
      onCancel={handleCloseModalholdPaout}
      footer={null}
      >
        <Select
            showSearch
            placeholder="Select Reasion"
            optionFilterProp="label"
            onChange={onChange}
            onSearch={onSearch}
            style={{ width: '100%', marginTop: "0.3rem" , marginBottom: "0.3rem"}}
            options={optionOfReasion}
          />
         <TextArea
                placeholder="Please add comment to submit"
                onChange={(e) => setPmapremark(e.target.value)}
                autoSize={{ minRows: 2, maxRows: 6 }}
              />
      </Modal> */}
      <PartnerChangeHistory
        partnerChangeData={partnerChangeData}
        setPartnerChangeData={setPartnerChangeData}
        partnerChangeOpen={partnerChangeOpen}
        setPartnerChangeOpen={setPartnerChangeOpen}
      // resData = {resData}
      />
      <RemarksComponent
        resData={resDataRM}
        remarks={remarks}
        setRemarks={setRemarks}
        isHistory={true}

      />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {

    getLanRemarkData: data => dispatch(getRemarksLanSuccess(data)),
    getremaphystorydata: data => dispatch(getremaphystorydata(data)),
  }
};

const mapStateToProps = (state) => {
  return {


    accessToken: state && state.auth && state.auth.idToken,
    userDetail: state.auth?.userData,
  };
}



export default connect(mapStateToProps, mapDispatchToProps)(LanlistWithPayoutCPChecker);